// extracted by mini-css-extract-plugin
export default {"content":"style_content__eWjg-","profileCard":"style_profileCard__smLJj"};